import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import Chip from '@mui/material/Chip';
import Link from '@mui/material/Link';
import Card from 'components/Card';
import CardContent from 'components/CardContent';
import SectionTitle from 'components/SectionTitle';
import { seeMoreProps } from 'services/urlService';

const emptyArray = [];

const Chips = styled('div')`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

const backgrounds = [
  'rgba(128, 128, 128, 0.16)',
  'rgba(128, 128, 128, 0.1)',
  'rgba(128, 128, 128, 0.06)',
];

const config = {
  shouldForwardProp: prop => prop !== 'depth',
};

const DepthChip = styled(Chip, config)`
  font-size: 0.8125rem;
  border: none;
  color: #444;

  background: ${({ depth }) => backgrounds[Math.min(depth, backgrounds.length - 1)]};

  &:hover {
    filter: brightness(0.95);
  }
`;

const ChipsWidget = ({ title, url, chips = emptyArray, ...rest }) => {

  if (chips.length === 0) {
    return null;
  }

  return (
    <div {...rest}>
      <Card>
        <CardContent>
          <SectionTitle seeMore={seeMoreProps(url)}>
            {url ? <Link color="inherit" underline="hover" {...seeMoreProps(url)}>{title}</Link> : title}
          </SectionTitle>
          <Chips>
            {chips.map(chip => (
              <DepthChip key={chip.url} depth={chip.depth ?? 0} label={chip.label} clickable {...seeMoreProps(chip.url)} />
            ))}
          </Chips>
        </CardContent>
      </Card>
    </div>
  );
};

ChipsWidget.propTypes = {
  title: PropTypes.node,
  url: PropTypes.string,
  chips: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.node,
    url: PropTypes.string.isRequired,
    depth: PropTypes.number,
  })),
};

export default ChipsWidget;
